module.exports = __webpack_public_path__ + "static/media/edenredlogo.66ec443e.svg";